module.exports = __webpack_public_path__ + "media/images/illustrations/400-error-bad-request-5d1be367f3dd302e0df3b92f23dd10aa.svg";